import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/payment-option";

export type TGetPaymentOption = {
  id?: string | number;
  source?: string | number;
  processing_type?: string;
  location?: string;
  active?: boolean;
};

export type TPostPaymentOption = {
  title: string;
  source: "online" | "in_person";
  accounting_reference_id: string | number;
  type?: string;
};

export type TPutPaymentOption = {
  id: string | number;
  title: string | number;
  accounting_reference_id: string | number;
  active: boolean;
  type?: string;
};

export async function GetPaymentOptions(params?: TGetPaymentOption, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/payment-option"), params, useGlobalLoader, token);
}

export async function PostPaymentOptions(params?: TPostPaymentOption, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/payment-option"), params, useGlobalLoader);
}

export async function PutPaymentOptions(params: TPutPaymentOption, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/payment-option"), params, useGlobalLoader);
}

export async function DeactivatePaymentOption(params: { id: string | number }, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/payment-option/deactivate"), params, useGlobalLoader);
}
export async function ReactivatePaymentOption(params: { id: string | number }, useGlobalLoader?: boolean) {
  return await APIPut(baseUrl + "/reactivate", params, useGlobalLoader);
}
